import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = css`
  padding-bottom: ${size[24]};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${size[32]};
  margin: 0 auto ${size[32]};

  ${breakpoint.up('smMd')} {
    padding-bottom: 0;
    max-width: ${width.container.wider};
    gap: ${size[40]};
  }
`

export const container = css`
  width: 100%;

  ${breakpoint.up('smMd')} {
    display: flex;
    flex-direction: column;
  }
`

export const offsets = css`
  padding: 0 ${size[24]};
`

export const head = css`
  width: 100%;

  ${breakpoint.up('smMd')} {
    display: none;
  }
`

export const description = css`
  margin-top: ${size[24]};
  font-size: ${fontSize.md};
  line-height: ${size[24]};

  ${breakpoint.up('smMd')} {
    max-width: ${width.container.compact};
    margin-top: ${size[40]};
  }
`

export const cta = css`
  padding: 0 ${size[24]};
  width: 100%;

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    padding: 0;
    width: fit-content;
    margin: 0 auto;
  }
`

export const pagination = css`
  padding: 0 ${size[24]};
  width: 100%;
`
